
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PointInfo',

  props: {
    label: {
      type: String,
      default: function() {
        return `現在の${this.$t('keyword.point')}`;
      },
    },
    point: {
      type: Number,
      default: null,
    },
    color: {
      type: String,
      default: '#48bdb8',
    },
  },
});
